
import util from '@/constants/utils'

// 任务状态
const taskStatus = [
    {
        label: '全部',
        label_t: 'biosafe.taskStatus',
        value: '0'
    },
    {
        label: '已填',
        label_t: 'biosafe.taskStatus',
        value: '1'
    },
    {
        label: '未填',
        label_t: 'biosafe.taskStatus',
        value: '2'
    },
    {
        label: '超期',
        label_t: 'biosafe.taskStatus',
        value: '3'
    }
]
// 卡状态
const cardType = [
    {
        label: '空白',
        label_t: 'biosafe.BLANK',
        value: 'BLANK'
    },
    {
        label: '正常',
        label_t: 'biosafe.ACTIVE',
        value: 'ACTIVE'
    },
    {
        label: '挂失',
        label_t: 'biosafe.FROZEN',
        value: 'FROZEN'
    },
    {
        label: ' 注销',
        label_t: 'biosafe.WITHDRAWN',
        value: 'WITHDRAWN'
    },
]
// 事件类型
const enterOrExitType = [
    { label: "全部", label_t: 'biosafe.table.enterOrExitType', value: '0' },
    { label: "进门", label_t: 'biosafe.table.enterOrExitType', value: '1' },
    { label: "出门", label_t: 'biosafe.table.enterOrExitType', value: '2' },
    { label: "进/出门", label_t: 'biosafe.table.enterOrExitType', value: '3' }
]
// 开门结果
const openResultType = [
    { label: "全部", label_t: 'biosafe.table.openResultType', value: '2' },
    { label: "成功", label_t: 'biosafe.table.openResultType', value: '1' },
    { label: "失败", label_t: 'biosafe.table.openResultType', value: '0' }
]

// 人员类型
const peopleType = [
    { label: "全部", label_t: 'biosafe.table.peopleType', value: '' },
    { label: "内部人员", label_t: 'biosafe.table.peopleType', value: '2' },
    { label: "访客", label_t: 'biosafe.table.peopleType', value: '1' }
]
// 是否
const isOrNot = [
    { label: "是", label_t: 'biosafe.table.isOrNot', value: '1' },
    { label: "否", label_t: 'biosafe.table.isOrNot', value: '0' },
]
// 是否
const isOrNotSelDic = [
    {
        label: '是',
        label_t: 'biosafe.enumClearSelDic',
        value: "1"
    },
    {
        label: '否',
        label_t: 'biosafe.enumClearSelDic',
        value: "0"
    }
]
// 性别
const sexDic = [
    {
        label: '男',
        label_t: 'biosafe.sexDic',
        value: '1'
    },
    {
        label: '女',
        label_t: 'biosafe.sexDic',
        value: '2'
    },
    {
        label: '未知',
        label_t: 'biosafe.sexDic',
        value: '0'
    },
]
// 人员身份
const identityDic = [
    {
        label: '访客',
        label_t: 'biosafe.identityDic',
        value: '0'
    },
    {
        label: '休班人员',
        label_t: 'biosafe.identityDic',
        value: '1'
    },
    {
        label: '离场人员',
        label_t: 'biosafe.identityDic',
        value: '2'
    },
    {
        label: '返场人员',
        label_t: 'biosafe.identityDic',
        value: '3'
    }
]
// 采样结果
const sampResultDic = [
    {
        label: '阴性',
        label_t: 'biosafe.sampResultDic',
        value: '1'
    },
    {
        label: '阳性',
        label_t: 'biosafe.sampResultDic',
        value: '2'
    }
    // ,
    // {
    //     label:'未知',
    //     label_t: 'biosafe.sampResultDic',
    //     value:'0'
    // }
]
// 字典是否启用
const enumStatDic = [
    {
        label: '启用',
        label_t: 'biosafe.enumStatDic',
        value: 1
    },
    {
        label: '不启用',
        label_t: 'biosafe.enumStatDic',
        value: 2
    }
]
// 是否
const enumClearDic = [
    {
        label: '全部',
        label_t: 'biosafe.enumClearDic',
        value: "0"
    },
    {
        label: '是',
        label_t: 'biosafe.enumClearDic',
        value: "1"
    },
    {
        label: '否',
        label_t: 'biosafe.enumClearDic',
        value: "2"
    }
]
// 是否
const enumClearSelDic = [
    {
        label: '是',
        label_t: 'biosafe.enumClearSelDic',
        value: "1"
    },
    {
        label: '否',
        label_t: 'biosafe.enumClearSelDic',
        value: "2"
    }
]
//-- 出猪前采样类型
const enumClearSklDic = [
    {
        label: '--',
        label_t: 'biosafe.enumClearSklDic',
        value: "1"
    },
    {
        label: '出猪前采样',
        label_t: 'biosafe.enumClearSklDic',
        value: "2"
    },
    {
        label: "出猪后采样",
        label_t: 'biosafe.enumClearSklDic',
        value: "3"
    }
]
//-- 出猪前洗消类型
const enumClearOutSklDic = [
    {
        label: '--',
        label_t: 'biosafe.enumClearOutSklDic',
        value: "1"
    },
    {
        label: '出猪前洗消',
        label_t: 'biosafe.enumClearOutSklDic',
        value: "2"
    },
    {
        label: "出猪后洗消",
        label_t: 'biosafe.enumClearOutSklDic',
        value: "3"
    }
]
//-- 卸猪采样类型
const enumOutPigeSklDic = [
    {
        label: '--',
        label_t: 'biosafe.enumOutPigeDic',
        value: "1"
    },
    {
        label: '卸猪前采样',
        label_t: 'biosafe.enumOutPigeDic',
        value: "2"
    },
    {
        label: "卸猪后采样",
        label_t: 'biosafe.enumOutPigeDic',
        value: "3"
    }
]
// 猪群健康状况
const enumHealthSklDic = [
    {
        label: '健康',
        label_t: 'biosafe.enumClearHealthDic',
        value: "1"
    },
    {
        label: '较健康',
        label_t: 'biosafe.enumClearHealthDic',
        value: "2"
    },
    {
        label: "不健康",
        label_t: 'biosafe.enumClearHealthDic',
        value: "3"
    }
]
// 是否清除
const enumHealthClearSklDic = [
    {
        label: '确认',
        label_t: 'biosafe.ClearHealthDic',
        value: "1"
    },
    {
        label: '不确认',
        label_t: 'biosafe.ClearHealthDic',
        value: "2"
    }
]
// 人员采样管理 页面数据的状态：未采样,已下发,已清离
const enumSampStatueDic = [
    {
        label: '未采样',
        label_t: 'biosafe.enumSampStatueDic',
        value: 0
    },
    {
        label: '已下发',
        label_t: 'biosafe.enumSampStatueDic',
        value: 1
    },
    {
        label: '已清离',
        label_t: 'biosafe.enumSampStatueDic',
        value: 2
    }
]

export default {
    // 所有字典类型
    allEnumList: [],
    // 字典数据：key是类型id，value是字典数组
    allEnumDic: JSON.parse(localStorage.getItem('allEnumDic')) || {},
    // 所有猪场类型
    allScene:  JSON.parse(localStorage.getItem('allScene')) || [],
    // 开门类型
    allOpenType: JSON.parse(localStorage.getItem('allOpenType')) || [],
    /**
    * 保存所有字典数据
    * @param {Array} data
    */
    saveEnumData: function (data) {
        if (data && util.getDataType(data) === 'array') {
            this.allEnumList = data
            data.forEach(item => {
                item.codeList = item.codeList.map(obj => { return Object.assign(obj, { label: obj.itemName, text: obj.itemName, value: obj.itemCode }) })
                this.allEnumDic[item.id] = item.codeList
            })
            localStorage.setItem('allEnumList', JSON.stringify(this.allEnumList))
            localStorage.setItem('allEnumDic', JSON.stringify(this.allEnumDic))

        }
    },
    /**
     * 根据类型id或者类型名称获取该类型的字典数据
     * @param {Number|String} type 字段类型或字段名称
     */
    getEnumListByType: function (type) {
        let dataType = util.getDataType(type)
        let newArr = [...this.allEnumList]
        let list = []
        for (let i = 0; i < newArr.length; i++) {
            if (dataType === 'string') {
                if (newArr[i]['typeName'] === type) {
                    list = newArr[i]['codeList']
                    break
                }
            } else if (dataType === 'number') {
                if (newArr[i]['id'] === type) {
                    list = newArr[i]['codeList']
                    break
                }
            }
        }
        return list
    },
    /**
     * 获取指定类型字典的值
     * @param {Number|String} type 字段类型或字段名称
     * @param {String} key 字典编码
     */
    getEnumValue: function (type, key) {
        let list = this.getEnumListByType(type)
        let item = list.filter(obj => { return obj.itemCode === key })
        item = item && item.length > 0 ? item[0] : {}
        return item && item.itemName ? item.itemName : '--'
    },
    /**
     * 保存所有猪场数据
     * @param {Array} data
     */
    saveSceneData: function (data) {
        if (data && util.getDataType(data) === 'array') {
            let list = data.map(obj => { return Object.assign(obj, { text: obj.domainName, label: obj.domainName, value: obj.domainId }) })
            this.allScene = list
            localStorage.setItem('allScene', JSON.stringify(this.allScene))
        }
    },
    /**
    * 保存所有开门类型数据
    * @param {Array} data
    */
    saveOpenType: function (data) {
        if (data && util.getDataType(data) === 'array') {
            let list = data.map(obj => { return Object.assign(obj, { text: obj.value, label: obj.value, value: obj.id + '' }) })
            this.allOpenType = list
            localStorage.setItem('allEnumDic', JSON.stringify(this.allOpenType))
        }
    },
    taskStatus,
    sexDic,
    identityDic,
    sampResultDic,
    enumStatDic,
    enumClearDic,
    enumClearSelDic,
    enumSampStatueDic,
    // 访客记录字典
    cardType,
    enterOrExitType,
    openResultType,
    isOrNot,
    isOrNotSelDic,
    peopleType,
    enumClearSklDic,
    enumHealthSklDic,
    enumHealthClearSklDic,
    enumOutPigeSklDic,
    enumClearOutSklDic
}


